import React from "react"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { Dialog, useMediaQuery, DialogContent } from "@material-ui/core"
import "github-markdown-css"
import CloseIcon from "atoms/icon/CloseIcon"
import { backgroundFixed } from "utils/backgroundFixed.js"

const useStyles = makeStyles(theme => ({
  paperFullWidth: {},
  paper: {
    overflow: "visible",
  },
  content: {
    [theme.breakpoints.down("xs")]: {
      maxHeight: "calc(100vh - 366px)",
    },
    maxHeight: "calc(100vh - 302px)",
    whiteSpace: "pre-line",
    wordBreak: "normal",
    paddingLeft: "23px",
    paddingRight: "23px",
    marginTop: "25px",
    marginBottom: "20px",
  },
  modalContentText: {
    fontWeight: 400,
    color: "#333",
    lineHeight: "18px",
    textAlign: "left",
    paddingBottom: "12px",
    marginBottom: "6px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
  },
  modalContentList: {
    marginTop: "0px",
    marginBottom: "0px",
    listStyle: "none",
  },
}))

function useWidth() {
  const theme = useTheme()
  const keys = [...theme.breakpoints.keys].reverse()
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key))
      return !output && matches ? key : output
    }, null) || "xs"
  )
}

const StyledDialog = withStyles({
  paperFullWidth: {
    width: "calc(100vw - 30px)",
    maxWidth: "960px",
  },
  paper: {
    marginLeft: "15px",
    marginRight: "15px",
    marginTop: "34px",
    borderRadius: "8px",
  },
})(Dialog)

const CampaignModal = ({ open, onClose, onBackground, card }) => {
  const classes = useStyles()
  const maxWidth = useWidth()

  return (
    <StyledDialog
      fullWidth
      maxWidth={maxWidth}
      open={open}
      onClose={onBackground}
      TransitionProps={{ onEnter: () => backgroundFixed(true) }}
      aria-labelledby="max-width-dialog-title"
      className="agreement-manga-modal"
      classes={{ paper: classes.paper }}
    >
      <CloseIcon id="campaignModalCloseButton" onClick={onClose} />
      <DialogContent className={classes.content}>
        <div id="campaignModalContent">
          <p className={classes.modalContentText}>
            株式会社NTTドコモ（以下「当社」といいます）が実施する「同意でdポイント最大10,000ポイントプレゼントキャンペーン
            」（以下「本キャンペーン」といいます）は、この規約（以下「本規約」といいます）に従って実施いたします。本キャンペーンへのエントリーにあたっては、以下の内容を必ずご確認ください
          </p>
          <p className={classes.modalContentText}>
            ■キャンペーン期間
            <br />
            2024年11月18日（月）10:00 ～ 2024年12月10日（火）13:00
            <br />
            <span style={{ fontWeight: "bold" }}>
              ※予算上限に到達次第、キャンペーンを終了いたします
            </span>
          </p>
          <p className={classes.modalContentText}>
            ■キャンペーン概要／応募条件
            <br />
            キャンペーン期間内に以下の応募条件のすべて満たすと、抽選でdポイント10～10,000ポイント（期間・用途限定）進呈いたします
            <br />
            ※10,000ポイント×月20本、1,000ポイント×月50本、その他ポイントプレゼント対象の方は10ポイント進呈
            <br />
            ※キャンペーンコード：MI000010
          </p>
          <p className={classes.modalContentText}>
            ＜対象条件＞
            <br />
            ●dアカウントをお持ちの方
            <br />
            ●dポイントクラブ会員の方（ドコモビジネスメンバーズ会員もしくはビジネスdアカウントの方は対象外です)
            <br />
            ●「個人関連情報の個人データとしての取得・利用」「広告目的でのIPアドレス利用」「第三者提供」のうち本画面に表示されたすべての同意事項に同意いただいた方*1
            <br />
            ※既に同意済みの同意事項は表示されません
            <br />
            ●プレゼント対象者となった月から起算して翌々月末日まで、
            「個人関連情報の個人データとしての取得・利用」「広告目的でのIPアドレス利用」「第三者提供」の同意を継続されている方
          </p>
          <p className={classes.modalContentText}>
            ■ポイントの進呈について
            <br />
            ・キャンペーンでの付与ポイントは、dポイント（期間・用途限定）となり、本画面で同意いただいた月から起算して翌々月までに対象のdポイントクラブ会員に進呈予定です
            <br />
            ※ポイントの進呈時期は目安であり、遅れる場合がございます
            <br />
            ※ポイントの進呈はdポイントクラブ会員おひとりにつき1回限りとなります
            <br />
            ※本キャンペーンの当選発表は、キャンペーンポイントの進呈にてさせていただきます
            <br />
            ・進呈するポイントの有効期間は、進呈日から2か月となります
            <br />
            ・ポイント進呈前に、dポイントクラブの退会、dポイントカード／モバイルdポイントカード／dカード
            GOLD／dカード／dカード
            プリペイドの利用登録の削除などをされた場合、キャンペーンポイントが進呈されませんのでご注意ください
            <br />
            ・進呈されたキャンペーンポイントおよび有効期間に関しては、「dポイントクラブアプリ」または「dポイントクラブサイト」からご確認いただけます
          </p>
          <div className={classes.modalContentText}>
            ■注意事項
            <br />
            ・以下の場合、本キャンペーンへの参加およびポイント進呈は無効となります
            <ul className={classes.modalContentList}>
              <li>
                （ア）キャンペーンポイントの進呈前に本キャンペーンの応募条件を満たさなくなった場合
              </li>
              <li>
                （イ）本キャンペーンで故意に複数アカウントでエントリーするなど不正行為が行われたと当社が判断した場合
              </li>
              <li>
                （ウ）本規約その他当社の利用規約に違反する行為があった場合、またはその恐れがあると当社が判断した場合
              </li>
            </ul>
            ・システムメンテナンスなどで「個人関連情報の個人データとしての取得・利用」「広告目的でのIPアドレス利用」「第三者提供」に同意できない場合があります
          </div>
        </div>
      </DialogContent>
    </StyledDialog>
  )
}

export default CampaignModal
